// routes
export const REVIEW = "review";
export const APPLY = "apply";
export const DECLINE = "decline";
export const JOB_DESCRIPTION = "job-description";

export const CANDIDATE_CONFIRMATION_BODY_CLASS = "body--candidate-confirm";
export const MAIN_CONTAINER_MIN_WIDTH_CLASS = "main-container-min-width";
